// Wire DTOs live in services/products/types.ts; re-exported here so the mapping dialog has one import.
export type {
  XmlCatalogField,
  XmlFieldMapping,
  XmlFieldProposal,
  XmlHeaderMapEntry,
  XmlItemSampleEntry,
  XmlMappingConfirmation,
  XmlPathInventoryEntry,
} from '@/services/products/types'

// The verbatim message for a lost-race / repeat confirmation, exported so callers can tell it apart from the retryable 409.
export const XML_MAPPING_ALREADY_CONFIRMED_MESSAGE =
  'This feed mapping has already been confirmed'

// Radix rejects an empty item value, so the unmapped choice carries a sentinel.
export const XML_NOT_MAPPED_VALUE = '__not_mapped__'

export class XmlMappingConflictError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'XmlMappingConflictError'
  }
}
